import React, { useState } from "react"
import { Backdrop, CircularProgress, Typography } from "@mui/material"
import InfoIcon from "@mui/icons-material/Info"

import useStyles from "./useStyles"
import { SearchCuit } from "../SearchCuit/SearchCuit"
import BreadcrumbsComponent from "../Breadcrumbs/Breadcrumbs"
export const DeclarationHome = () => {
  const classes = useStyles()
  const [loading] = useState(false)
  const [valueFilter, setValueFilter] = useState(null)

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>Declaraciones juradas</Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: "2rem", color: "#00a78f", marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá buscar las declaraciones del Estudio asociado a
          una Organización.
        </Typography>
      </div>
      <SearchCuit valueFilter={valueFilter} setValueFilter={setValueFilter} />
    </div>
  )
}
